import type { ReqConfig } from '../model'

export const getDefaultHeaders = (reqConfig: Partial<ReqConfig>) => {
  const autoContentType = reqConfig?.autoContentType === true

  const defaultHeaders = {}

  if (!autoContentType) {
    defaultHeaders['Content-Type'] = 'application/json'
  }

  return defaultHeaders
}
